import React, { useEffect, useRef, useState } from "react";
import {
  AccessibilityInfo,
  Animated,
  Platform,
  StyleSheet,
  Text,
  View,
} from "react-native";
import { t } from "@/localization";

// FuneralFolio's assistant bubble and staggered dots, using native animations.
export default function TypingIndicator() {
  const dots = useRef([0, 1, 2].map(() => new Animated.Value(0))).current;
  const [reduceMotion, setReduceMotion] = useState(true);
  useEffect(() => {
    let active = true;
    AccessibilityInfo.isReduceMotionEnabled().then((value) => {
      if (active) setReduceMotion(value);
    });
    const subscription = AccessibilityInfo.addEventListener(
      "reduceMotionChanged",
      setReduceMotion
    );
    return () => {
      active = false;
      subscription.remove();
    };
  }, []);
  useEffect(() => {
    if (reduceMotion) return;
    const animations = dots.map((dot, index) =>
      Animated.loop(
        Animated.sequence([
          Animated.delay(index * 150),
          Animated.timing(dot, {
            toValue: -5,
            duration: 230,
            useNativeDriver: Platform.OS !== "web",
          }),
          Animated.timing(dot, {
            toValue: 0,
            duration: 230,
            useNativeDriver: Platform.OS !== "web",
          }),
          Animated.delay(540 - index * 150),
        ])
      )
    );
    animations.forEach((animation) => animation.start());
    return () => {
      animations.forEach((animation) => animation.stop());
      dots.forEach((dot) => dot.setValue(0));
    };
  }, [dots, reduceMotion]);
  return (
    <View
      accessible
      accessibilityLabel={t("AI assistant is typing")}
      accessibilityLiveRegion="polite"
      style={styles.bubble}
    >
      <Text style={styles.label}>{t("AI assistant")}</Text>
      <View style={styles.dots}>
        {dots.map((dot, index) => (
          <Animated.View
            key={index}
            style={[styles.dot, { transform: [{ translateY: dot }] }]}
          />
        ))}
      </View>
    </View>
  );
}
const styles = StyleSheet.create({
  bubble: {
    alignSelf: "flex-start",
    marginRight: 16,
    borderRadius: 16,
    backgroundColor: "#FFF5F2",
    paddingHorizontal: 16,
    paddingVertical: 12,
  },
  label: { fontSize: 12, fontWeight: "600", color: "#A9321E", marginBottom: 8 },
  dots: { flexDirection: "row", gap: 6, height: 14, alignItems: "center" },
  dot: { width: 8, height: 8, borderRadius: 4, backgroundColor: "#F84123" },
});
